<template>
  <v-card class="px-2 py-2 border border-black" elevation="0">
    <!-- Title Slot -->
    <div class="d-flex align-center">
      <slot name="icon"></slot>
      <div class="text-h6 font-weight-bold ml-2 color-custom-blue">
        <slot name="title"></slot>
      </div>
    </div>

    <v-divider class="mt-2 mb-0"></v-divider>

    <!-- Content Slot -->
    <div class="mt-2">
      <slot name="content"></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "NewLeadCardSlot",
};
</script>
